import { bcbs_groupconfigurationsnapshot } from "model/CRM";
import { IAccountsReceivable, IBenefit, ICESNumber, IDepartment, IFeesAndPremiums, IFlexibleFieldSet, IGroupConfigurationData, IGroupNumber, INonStandard, INonStandardTemplate, IPlan, IStopLoss } from "model/FlexibleAttributeModel";

export enum EJsonTransformMode {
    New,
    Edit,
    Readonly
}

export enum ETransformContextType {
    GroupConfiguration,
    Plan,
    Benefit,
    AccountsReceivable,
    FeesAndPremium,
    StopLoss
}

export interface ITransformContext {
    type: ETransformContextType;
    parent: any;
}

export interface IBenefitTransformContext {
    type: ETransformContextType.Benefit;
    parent: IBenefit;
}

export interface IGroupConfigurationTransformContext {
    type: ETransformContextType.GroupConfiguration;
    parent: IGroupConfigurationData;
}

export interface IJsonTransformer {
    before(json: IGroupConfigurationData): Promise<void>;
    transformGroupConfiguration(json: IGroupConfigurationData, snapshot: bcbs_groupconfigurationsnapshot): Promise<void>;
    transformNonStandardTemplate(nonStandardTemplate: INonStandardTemplate): Promise<boolean | void>;
    transformPlan(plan: IPlan): Promise<boolean | void>;
    transformBenefit(benefit: IBenefit): Promise<boolean | void>;
    transformAccountsReceivable(accountsReceivable: IAccountsReceivable): Promise<boolean | void>;
    transformFeesAndPremium(feesAndPremium: IFeesAndPremiums): Promise<boolean | void>;
    transformStopLoss(stopLoss: IStopLoss): Promise<boolean | void>;
    transformAttributeSet(attributeSet: IFlexibleFieldSet, context: ITransformContext): Promise<boolean | void>;
    transformNonStandard(nonStandard: INonStandard, context: ITransformContext): Promise<boolean | void>;
    transformGroupNumber(groupNumber: IGroupNumber): Promise<boolean | void>;
    transformCESNumber(cesNumber: ICESNumber): Promise<boolean | void>;
    transformDepartment(department: IDepartment): Promise<boolean | void>;
    after(json: IGroupConfigurationData): Promise<void | void>;
}

export class BaseJsonTransformer implements IJsonTransformer {

    async before(json: IGroupConfigurationData): Promise<void> { }

    async transformGroupConfiguration(json: IGroupConfigurationData, snapshot: bcbs_groupconfigurationsnapshot): Promise<void> { }
    async transformPlan(plan: IPlan): Promise<boolean | void> { }
    async transformBenefit(benefit: IBenefit): Promise<boolean | void> { }
    async transformAccountsReceivable(accountsReceivable: IAccountsReceivable): Promise<boolean | void> { }
    async transformFeesAndPremium(feesAndPremium: IFeesAndPremiums): Promise<boolean | void> { }
    async transformStopLoss(stopLoss: IStopLoss): Promise<boolean | void> { }
    async transformAttributeSet(attributeSet: IFlexibleFieldSet, context: ITransformContext): Promise<boolean | void> { }
    async transformNonStandard(nonStandard: INonStandard, context: ITransformContext): Promise<boolean | void> { }
    async transformGroupNumber(groupNumber: IGroupNumber): Promise<boolean | void> { }
    async transformCESNumber(cesNumber: ICESNumber): Promise<boolean | void> { }
    async transformDepartment(department: IDepartment): Promise<boolean | void> { }
    async transformNonStandardTemplate(nonStandardTemplate: INonStandardTemplate): Promise<boolean | void> { }

    async after(json: IGroupConfigurationData): Promise<void> { }
}